import '../../style/map.scss';
import { fetchSigmets } from '../helperfunctions';

import {
  sigmetDrawKey,
  sigmetsToFeatureCollection,
} from './sigmetGeometry';
import { zonesAtPoint } from './zoneClick.js';
import { areaAtIndex } from './areaHelperFunctions.js';

const SOURCE_ID = 'sigmets';
const FILL_ID = 'sigmets-fill';
const OUTLINE_ID = 'sigmets-outline';

// ponytail: one map. A second concurrent map would share this fetch counter.
let requestSeq = 0;
let pointerHandlers = null;
let drawnKey = '';

// Layers stay up across map redraws. A newer fetch replaces the polygons in
// place, and an older response is ignored, so the areas do not blink off.
export function addSIGMETareas(map, handleOpenSigmetModal) {
  const requestId = ++requestSeq;

  fetchSigmets()
    .then((response) => response.json())
    .then((sigmetData) => {
      if (requestId !== requestSeq || !map.current) return;
      const data = sigmetsToFeatureCollection(sigmetData);
      if (!map.current.isStyleLoaded()) {
        map.current.once('idle', () => {
          if (requestId !== requestSeq || !map.current) return;
          drawSigmets(map, data, handleOpenSigmetModal);
        });
        return;
      }
      drawSigmets(map, data, handleOpenSigmetModal);
    })
    .catch((error) => {
      console.error('Error fetching SIGMET data:', error);
          });
}

export function removeSIGMETareas(map) {
  requestSeq += 1;
  drawnKey = '';
  unbindPointer(map);
  if (!map.current || !map.current.isStyleLoaded()) return;
  if (map.current.getLayer(FILL_ID)) map.current.removeLayer(FILL_ID);
  if (map.current.getLayer(OUTLINE_ID)) map.current.removeLayer(OUTLINE_ID);
  if (map.current.getSource(SOURCE_ID)) map.current.removeSource(SOURCE_ID);
}

function drawSigmets(map, data, handleOpenSigmetModal) {
  const key = sigmetDrawKey(data);
  if (key === drawnKey && map.current.getLayer(FILL_ID)) return;
  drawnKey = key;

  if (map.current.getSource(SOURCE_ID)) {
    map.current.getSource(SOURCE_ID).setData(data);
        } else {
    map.current.addSource(SOURCE_ID, {
            type: 'geojson',
      data,
          });
        }

  if (!map.current.getLayer(FILL_ID)) {
          map.current.addLayer({
      id: FILL_ID,
            type: 'fill',
      source: SOURCE_ID,
            layout: {},
            paint: {
        'fill-color': '#D81939',
              'fill-opacity': 0.5,
            },
          });
        }

  if (!map.current.getLayer(OUTLINE_ID)) {
          map.current.addLayer({
      id: OUTLINE_ID,
            type: 'line',
      source: SOURCE_ID,
            layout: {},
            paint: {
        'line-color': '#D81939',
              'line-width': 2,
            },
          });
        }

  unbindPointer(map);
  bindPointer(map, handleOpenSigmetModal);
}

function unbindPointer(map) {
  if (!pointerHandlers || !map.current) return;

  for (let i = 0; i < pointerHandlers.layers.length; i++) {
    const layerId = pointerHandlers.layers[i];
    map.current.off('click', layerId, pointerHandlers.click);
    map.current.off('mouseenter', layerId, pointerHandlers.enter);
    map.current.off('mouseleave', layerId, pointerHandlers.leave);
  }
  pointerHandlers = null;
}

function bindPointer(map, handleOpenSigmetModal) {
  const click = (event) => {
    const items = zonesAtPoint(map.current, event.point, areaAtIndex);
    if (!items.length) return;
    handleOpenSigmetModal({ items });
  };
  const enter = () => {
          map.current.getCanvas().style.cursor = 'pointer';
          };
  const leave = () => {
          map.current.getCanvas().style.cursor = '';
          };
  const layers = [FILL_ID, OUTLINE_ID];

  for (let i = 0; i < layers.length; i++) {
    map.current.on('click', layers[i], click);
    map.current.on('mouseenter', layers[i], enter);
    map.current.on('mouseleave', layers[i], leave);
        }
  pointerHandlers = { click, enter, leave, layers };
}
